import Filter from "@base/Filter/Filter"

export default Filter;
